export default "__VITE_ASSET__Bzs5Gyl2__"